module.exports = ".palette-row {\n  display: inline-block;\n  width: calc(10 * 18px);\n  margin: 0 8px; }\n\n.color-cell {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  margin: 1px;\n  border: solid 1px #eee;\n  cursor: pointer; }\n\n.color-cell:hover {\n  -webkit-transform: scale(1.1);\n          transform: scale(1.1); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/silk/toolbars/standard-toolbar/color-dropdown/color-dropdown.component.scss
// module id = ./src/app/shared/components/silk/toolbars/standard-toolbar/color-dropdown/color-dropdown.component.scss
// module chunks = main